import { render, staticRenderFns } from "./queryRight.vue?vue&type=template&id=5dae3341&scoped=true"
import script from "./queryRight.vue?vue&type=script&lang=js"
export * from "./queryRight.vue?vue&type=script&lang=js"
import style0 from "./queryRight.vue?vue&type=style&index=0&id=5dae3341&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae3341",
  null
  
)

export default component.exports